/**
 * Find the looking ID tag from within product tags
 * @param {object} product - Expects Product JSON with Product Tags Array
 * @returns
 */
const getProductTags = (product, prefix, separator = ':') => {
  if (!product || !product.tags) return;
  let productTags = [];

  let fullPrefix = `${prefix}${separator}`;

  product.tags.forEach((tag) => {
    if (tag.includes(fullPrefix)) {
      productTags.push(tag);
    }
  });

  return productTags;
};

/**
 * Set multuple attributes to node
 * @param {node} el - Expects node to assign attributes
 * @param {object} attrs - object of attributes to assign
 */
const setAttributes = (el, attrs) => {
  for (var key in attrs) {
    el.setAttribute(key, attrs[key]);
  }
};

/**
 * Get all products with same style ID
 * @param {string} styleTag - Expects a string with format `style:${STYLEID}`
 * @returns
 */
const getAllProductsByStyle = async (styleTag) => {
  if (!styleTag) return;
  const response = await fetch(`/collections/all${`/${styleTag}`}?view=data`)
    .then(async (response) => {
      if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        throw new Error(message);
      }
      const json = await response.json();
      return json;
    })
    .catch((error) => console.warn(error));

  return response;
};

/**
 * Get other products with same style ID
 * @param {integer} productId - Product ID of the product you want excluded from response
 * @param {string} styleTag  - Expects a string with format `style:${STYLEID}`
 * @returns
 */
const getOtherProductsByStyle = async (productId, styleTag) => {
  if (!productId || !styleTag) return;

  const response = await fetch(`/collections/all${`/${styleTag}`}?view=json`)
    .then(async (response) => {
      if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        throw new Error(message);
      }
      const json = await response.json();
      return json;
    })
    .catch((error) => console.warn(error));

  const filteredResponse = response;

  if (!filteredResponse.products) return;

  const filteredProducts = filteredResponse.products.filter(
    (product, index, arr) => {
      return product.id != productId;
    },
  );

  filteredResponse.products = filteredProducts;

  return filteredResponse;
};

/**
 * Get query parameter value from query parameter name
 * @param {string} parameterName - query parameter name
 * @returns
 */
const findGetParameter = (parameterName) => {
  let result = null,
    tmp = [];
  location.search
    .substr(1)
    .split('&')
    .forEach(function (item) {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
};

export {
  getAllProductsByStyle,
  getOtherProductsByStyle,
  getProductTags,
  setAttributes,
  findGetParameter,
};
